import Contact from './Contact.vue';
import Home from './Home.vue';
import Profile from './Profile.vue';
import Skill from './Skill.vue';
import Work from './Work.vue';
export default { Contact, Home, Profile, Skill, Work };
